module.exports = __webpack_public_path__ + "skins/Vizor1-01-0985438a88963f6803311ed99b17f7f4.wsz";


//////////////////
// WEBPACK FOOTER
// ./skins/Vizor1-01.wsz
// module id = 135
// module chunks = 5